import { render, staticRenderFns } from "./home.vue?vue&type=template&id=3e5d1de8&"
import script from "./home.vue?vue&type=script&lang=ts&"
export * from "./home.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports